import { render, staticRenderFns } from "./linkFile.vue?vue&type=template&id=2b51476b&scoped=true&"
import script from "./linkFile.vue?vue&type=script&lang=js&"
export * from "./linkFile.vue?vue&type=script&lang=js&"
import style0 from "./linkFile.vue?vue&type=style&index=0&id=2b51476b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b51476b",
  null
  
)

export default component.exports